// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background-image: linear-gradient(45deg, #329E9B 0%, #96D6D9 100%);
  height: 100%;
  background-size: cover;
  min-height: 550px;
}
h6 {
  color: #4E495C;
  margin-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./app/login/login.less"],"names":[],"mappings":"AAEC;EAEG,kEAAA;EAEA,YAAA;EACA,sBAAA;EACA,iBAAA;AAHJ;AAMC;EAEG,cAAA;EAEA,mBAAA;AANJ","sourcesContent":[" @import (reference) '../../node_modules/unison/dist/css/unison.less';\n \n html {\n    // These colors were pulled from the curalate logo\n    background-image: linear-gradient(45deg, #329E9B 0%, #96D6D9 100%);\n    // Cover full background with gradient\n    height: 100%;\n    background-size: cover;\n    min-height: 550px;\n }\n\n h6 {\n    // Use darkest gray for section headers\n    color: @cu-gray-9;\n    // Larger margin afterwards.\n    margin-bottom: @cu-spacing-4;\n }\n "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
